import React from "react";

export const BasicAuthContext = React.createContext({});